import { call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import userAPI from '../../../../user/api/UserAPI';
import { FETCH_USER_MRD_IMPC_SELECTIONS_REQUEST, DELETE_USER_MRD_IMPC_SELECTION_REQUEST } from '../../../../user/redux/actions/types/UserActionTypes';
import {
  fetchUserMrdImpcSelectionsFailureActionCreator,
  fetchUserMrdImpcSelectionsSuccessActionCreator,
  deleteUserMrdImpcSelectionFailureActionCreator,
  deleteUserMrdImpcSelectionSuccessActionCreator,
} from '../../../../user/redux/actions/UserActions';
import { postMrdPostalOperatorsImpc } from '../../api/MrdPostalOperatorsApi';
import {
  departureMailProcessingCenterCheckedActionCreator,
  retrieveOutboundPostalOperatorsFailureActionCreator,
  retrieveOutboundPostalOperatorsSuccessActionCreator,
} from '../actions/DeparturePostalOperatorActions';
import {
  arrivalMailProcessingCenterCheckedActionCreator,
  retrieveInboundPostalOperatorsFailureActionCreator,
  retrieveInboundPostalOperatorsSuccessActionCreator,
} from '../actions/ArrivalPostalOperatorActions';
import { RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_REQUEST } from '../actions/types/DeparturePostalOperatorActionTypes';
import { RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_REQUEST } from '../actions/types/ArrivalPostalOperatorActionTypes';
import OperatorTypes from '../../../../common/redux/actions/types/OperatorTypes';
import DirectionTypes from '../../../../common/redux/actions/types/DirectionTypes';

function* retrieveOutboundPostalOperatorWorker(action) {
  const operatorType = OperatorTypes.DEPARTURE;
  const stretch = action.payload.defaultDirection === DirectionTypes.INBOUND ? 'INBOUND' : 'OUTBOUND';
  try {
    const postalOperatorsResponse = yield call(postMrdPostalOperatorsImpc, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(retrieveOutboundPostalOperatorsSuccessActionCreator(postalOperatorsResponse.data));

    if (action.departureCheckedMailProcessingCenters && action.departureCheckedMailProcessingCenters.length) return;

    const lastUserIMPCSelectionResponse =
      yield call(userAPI.getLastUserMrdImpcSelection, operatorType);
    const lastUserIMPCSelection = lastUserIMPCSelectionResponse.data;

    if (lastUserIMPCSelection && action.reportDefinition !== 'Admin') {
      yield put(departureMailProcessingCenterCheckedActionCreator(
        lastUserIMPCSelection.impcCodes,
        action.reportDefinition,
      ));
    }
  } catch (error) {
    yield put(retrieveOutboundPostalOperatorsFailureActionCreator(error));
  }
}

function* retrieveInboundPostalOperatorWorker(action) {
  let operatorType = action.payload.defaultDirection === DirectionTypes.INBOUND ?
    OperatorTypes.ARRIVAL : OperatorTypes.DEPARTURE;
  const stretch = action.payload.defaultDirection === DirectionTypes.INBOUND ? 'INBOUND' : 'OUTBOUND';
  try {
    const postalOperatorsResponse = yield call(postMrdPostalOperatorsImpc, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(retrieveInboundPostalOperatorsSuccessActionCreator(postalOperatorsResponse.data));

    if (action.arrivalCheckedUnlocodes && action.arrivalCheckedUnlocodes.length) return;

    let lastUserIMPCSelectionResponse =
      yield call(userAPI.getLastUserMrdImpcSelection, operatorType);
    let lastUserIMPCSelection = lastUserIMPCSelectionResponse.data;

    if ((stretch === 'INBOUND' && lastUserIMPCSelection.direction !== action.payload.defaultDirection) ||
        (stretch === 'OUTBOUND' && lastUserIMPCSelection.direction === action.payload.defaultDirection)) {
      operatorType = operatorType === OperatorTypes.DEPARTURE ?
        OperatorTypes.ARRIVAL : OperatorTypes.DEPARTURE;
      lastUserIMPCSelectionResponse = yield call(userAPI.getLastUserMrdImpcSelection, operatorType);
      lastUserIMPCSelection = lastUserIMPCSelectionResponse.data;
    }

    if (lastUserIMPCSelection) {
      if (stretch === 'INBOUND') {
        if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
          yield put(arrivalMailProcessingCenterCheckedActionCreator(
            lastUserIMPCSelection.impcCodes,
            action.reportDefinition,
          ));
        } else {
          yield put(departureMailProcessingCenterCheckedActionCreator(
            lastUserIMPCSelection.impcCodes,
            action.reportDefinition,
          ));
        }
      } else if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
        yield put(departureMailProcessingCenterCheckedActionCreator(
          lastUserIMPCSelection.impcCodes,
          action.reportDefinition,
        ));
      } else {
        yield put(arrivalMailProcessingCenterCheckedActionCreator(
          lastUserIMPCSelection.impcCodes,
          action.reportDefinition,
        ));
      }
    }
  } catch (error) {
    yield put(retrieveInboundPostalOperatorsFailureActionCreator(error));
  }
}

function* fetchUserIMPCSelectionsWorker(action) {
  try {
    const postalOperatorType = action.payload;

    const userMrdImpcSelectionsResponse = yield call(
      userAPI.getUserMrdImpcSelections,
      postalOperatorType,
    );
    const selections = userMrdImpcSelectionsResponse.data;

    yield put(fetchUserMrdImpcSelectionsSuccessActionCreator(postalOperatorType, selections));
  } catch (error) {
    yield put(fetchUserMrdImpcSelectionsFailureActionCreator(error));
  }
}

function* deleteUserIMPCSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserMrdImpcSelection, action.payload);
    yield put(deleteUserMrdImpcSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserMrdImpcSelectionFailureActionCreator(error));
  }
}

function* postalOperatorsWatcher() {
  yield takeLeading(RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_REQUEST, retrieveOutboundPostalOperatorWorker);
  yield takeLeading(RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_REQUEST, retrieveInboundPostalOperatorWorker);
  yield takeEvery(FETCH_USER_MRD_IMPC_SELECTIONS_REQUEST, fetchUserIMPCSelectionsWorker);
  yield takeEvery(DELETE_USER_MRD_IMPC_SELECTION_REQUEST, deleteUserIMPCSelectionsWorker);
}

export default postalOperatorsWatcher;
